import { Component, Input } from '@angular/core';
import { observeProperty } from '@lcms/shared/data-access-user';
import { Observable, map, tap } from 'rxjs';

@Component({
  selector: 'lcms-users-result',
  templateUrl: './users-result.component.html',
  styleUrls: ['./users-result.component.scss'],
})
export class UsersResultComponent {
  @Input() cmpData:any;
  @Input() showDetails?:boolean;
  data$:Observable<any> = observeProperty(this as UsersResultComponent,'cmpData').pipe(
    map((res)=>res.map((user:any)=>user?._source)),
    )
}
